<template>
  <div class="modal-overlay">
    <div
      class="modal-content-wrapper"
      aria-modal="true"
      role="dialog"
    >
      <div class="modal-header">
        Approve Quote
        <CloseSvg
          class="close"
          :dark="true"
          @click="onCloseClicked"
        />
      </div>
      <div class="modal-content">
        <p>
          Make sure you have carefully read and reviewed the following items.
        </p>
        <ul>
          <li>
            Terms and Conditions <a
              aria-label="Open Short Action Customs' Terms & Conditions Page (opens in a new window)"
              href="https://shortactioncustoms.com/terms-and-conditions/"
              target="_blank"
            >(Found here)</a>
          </li>
          <li>All parts for your quote</li>
          <li>All build specifications for your quote</li>
        </ul>
        <p>
          If you have any questions, please contact us at <a href="mailto:sales@shortactioncustoms.com">sales@shortactioncustoms.com</a> and we will gladly answer any questions.
        </p>
        <p>
          By approving this order, the customer is accepting our "Terms and Conditions" and confirming the specifications of their order. We do our best to ensure all of the details are correct, however it is the CUSTOMERS RESPONSIBILITY to ensure that all parts and build specifications are currently correct and during the duration of your order.
        </p>
        <p>
          Once approved, a Short Action Customs team member will receive your confirmation and request a deposit to start your order.
        </p>
        <p>
          Thank you for your business, <br>
          The Team at Short Action Customs
        </p>
      </div>
      <div class="modal-footer">
        <LockingButton
          class="save-button"
          :locked="saving"
          :text="'Approve'"
          @click="onApproveQuoteClicked"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CloseSvg from '@/components/svgs/CloseSvg.vue'
import LockingButton from '@/components/shared/LockingButton.vue'

export default defineComponent({
  name: 'QuoteApprovalModal',
  components: {
    CloseSvg,
    LockingButton
  },
  props: {
    quoteId: {
      type: Number,
      required: true
    },
    saving: {
      type: Boolean,
      required: true
    }
  },
  emits: ['approved', 'close'],
  mounted() {
    document.body.addEventListener('keyup', this.onKeyup)
  },
  unmounted() {
    document.body.removeEventListener('keyup', this.onKeyup)
  },
  methods: {
    onApproveQuoteClicked(): void {
      this.$emit('approved')
    },
    onCloseClicked(): void {
      this.$emit('close')
    },
    onKeyup(e: KeyboardEvent): void {
      if (e.key === 'Escape' || e.key === 'Esc')
        this.onCloseClicked()
    }
  }
})
</script>

<style scoped lang="scss">
.modal-overlay {
  @include modal-styles;

  > .modal-content-wrapper > .modal-content a {
    color: $Color-sac-orange;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
  }
}
</style>